// removed by extract-text-webpack-plugin
module.exports = {"link":"link--2RJU4","icon":"icon--250NH"};